import { Box, Button, ButtonGroup, Typography } from '@mui/material';
import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import AdminTab from '../PageStructure/AdminTab';
import { MODELS } from '../RbacConfig';
import EscalationApprovalViewDialog, {
  EscalationApprovalRecord,
} from './EscalationApprovalViewDialog';
import EscalationAssignmentTypeEditDialog, {
  EscalationAssignmentType,
} from './EscalationAssignmentTypeEditDialog';
import EscalationBuRequestMappingEditDialog, {
  EscalationBuRequestMapping,
} from './EscalationBuRequestMappingEditDialog';
import EscalationEditDialog, { EscalationRecord } from './EscalationEditDialog';
import EscalationHistoryViewDialog, {
  EscalationHistoryRecord,
} from './EscalationHistoryViewDialog';
import EscalationProductSupportEditDialog, {
  EscalationProductSupport,
} from './EscalationProductSupportEditDialog';
import EscalationTypeEditDialog, { EscalationType } from './EscalationTypeEditDialog';
import { ADMIN_URL_DATA_MANAGMENT } from '../PageStructure/admin-values';


type SectionKey =
  | 'requests'
  | 'approvals'
  | 'routing'
  | 'buMappings'
  | 'types'
  | 'assignmentTypes'
  | 'history';

const EscalationAdminPage = () => {
 
  const { tab1 } = useParams();
  const section: SectionKey = tab1 as SectionKey ?? 'requests';
  const navigate = useNavigate();
  
  
  const setSection = (value: SectionKey) => {
    navigate(`${ADMIN_URL_DATA_MANAGMENT}/escalation/${value}`);
  };

  return (
    <Box style={{ paddingTop: '10px' }}>
      
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        Manage escalation requests, workflow approvals, routing configuration, BU Jira request
        mappings, and audit history.
      </Typography>

      <ButtonGroup sx={{ mb: 3, flexWrap: 'wrap' }}>
        <Button
          variant={section === 'routing' ? 'contained' : 'outlined'}
          onClick={() => setSection('routing')}
        >
          Product Routing
        </Button>

        <Button
          variant={section === 'buMappings' ? 'contained' : 'outlined'}
          onClick={() => setSection('buMappings')}
        >
          BU Request Mappings
        </Button>

        <Button
          variant={section === 'types' ? 'contained' : 'outlined'}
          onClick={() => setSection('types')}
        >
          Escalation Types
        </Button>

        <Button
          variant={section === 'assignmentTypes' ? 'contained' : 'outlined'}
          onClick={() => setSection('assignmentTypes')}
        >
          Assignment Types
        </Button>

        <Button
          variant={section === 'requests' ? 'contained' : 'outlined'}
          onClick={() => setSection('requests')}
        >
          Current Escalations
        </Button>

        <Button
          variant={section === 'approvals' ? 'contained' : 'outlined'}
          onClick={() => setSection('approvals')}
        >
          Workflow Approvals
        </Button>

        <Button
          variant={section === 'history' ? 'contained' : 'outlined'}
          onClick={() => setSection('history')}
        >
          Audit Log
        </Button>
      </ButtonGroup>

      {section === 'requests' && (
        <AdminTab<EscalationRecord>
          model={MODELS.escalations}
          DialogComponent={EscalationEditDialog}
        />
      )}

      {section === 'approvals' && (
        <AdminTab<EscalationApprovalRecord>
          model={MODELS.escalationApprovals}
          DialogComponent={EscalationApprovalViewDialog}
          hideAdd
          canDeleteOverride={false}
        />
      )}

      {section === 'routing' && (
        <AdminTab<EscalationProductSupport>
          model={MODELS.escalationProductSupport}
          DialogComponent={EscalationProductSupportEditDialog}
        />
      )}

      {section === 'buMappings' && (
        <AdminTab<EscalationBuRequestMapping>
          model={MODELS.escalationBuRequestMappings}
          DialogComponent={EscalationBuRequestMappingEditDialog}
        />
      )}

      {section === 'types' && (
        <AdminTab<EscalationType>
          model={MODELS.escalationTypes}
          DialogComponent={EscalationTypeEditDialog}
        />
      )}

      {section === 'assignmentTypes' && (
        <AdminTab<EscalationAssignmentType>
          model={MODELS.escalationAssignmentTypes}
          DialogComponent={EscalationAssignmentTypeEditDialog}
        />
      )}

      {section === 'history' && (
        <AdminTab<EscalationHistoryRecord>
          model={MODELS.escalationHistory}
          DialogComponent={EscalationHistoryViewDialog}
          hideAdd
          canDeleteOverride={false}
        />
      )}
    </Box>
  );
};

export default EscalationAdminPage;